<template>
  <div class="bookBox-1 p20">
    <div class="titlebox">
      <h2>联系人管理</h2>
      <el-button type="primary" round @click="dialogFormVisible = true">添加</el-button>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%">
      <el-table-column
        align="center"
        type="index"
        label="序号"
        width="50">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        width="120">
      </el-table-column>
      <el-table-column
        prop="idName"
        label="证件类型"
        width="120">
      </el-table-column>
      <el-table-column
        prop="idNo"
        label="证件号"
        width="260">
      </el-table-column>
      <el-table-column
        prop="cellphone"
        label="手机号"
        width="200">
      </el-table-column>
      <el-table-column
        align="center"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="deletecontacts(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增联系人信息" :visible.sync="dialogFormVisible" center :width="addformWidth">
      <el-form ref="contactsForm" :model="contactsForm" :rules="contactsRules" label-position="left" label-width="70px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="contactsForm.name" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="cellphone">
          <el-input v-model="contactsForm.cellphone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idNo">
          <el-input v-model="contactsForm.idNo" placeholder="请输入身份证号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button class="bookbtn" @click="addContacts">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAppointmentContactsList, addAppointmentContacts, deleteAppointmentContacts } from '@/api/appointment/index'
export default {
  name: 'usercontact',
  data () {
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        if (value.length === 6 || value.length === 11) {
          callback()
        } else {
          return callback(new Error('请输入11位或者6位'))
        }
      }
    }
    let IsCard = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('身份证号不能为空'))
      } else {
        const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的身份证号'))
        }
      }
    }
    return {
      dialogFormVisible: false,
      addformWidth: '26%',
      tableData: [],
      contactsForm: {
        'name': '',
        'cellphone': '',
        'idNo': '',
        'userName': this.$cookie.get('wlymobilephone'),
        'departmentCode': this.$cookie.get('museumCode')
      },
      contactsRules: {
        name: [{required: true, message: '姓名不能为空', trigger: 'blur'}],
        cellphone: [{required: true, message: '请输入正确的手机号', validator: checkPhone, trigger: 'blur'}],
        idNo: [{required: true, message: '请输入身份证号', validator: IsCard, trigger: 'blur'}]
      }
    }
  },
  mounted () {
    this.getPerson()
  },
  methods: {
    /* 带星星 */
    setStar (name, front, after) {
      return name.substring(0, front) + '*'.repeat(name.length - (front + after)) + name.substring(name.length - after)
    },
    /* 获取联系人列表 */
    getPerson () {
      getAppointmentContactsList(this.$cookie.get('wlymobilephone'), this.$cookie.get('museumCode')).then(res => {
        if (res.data.status === 200) {
          res.data.data.forEach((item, index) => {
            item.idNo = this.setStar(item.idNo, 4, 4)
            if (item.idType === '0') item.idName = '身份证'
          })
          this.tableData = res.data.data
        }
      })
    },
    /* 删除联系人 */
    deletecontacts (val) {
      deleteAppointmentContacts(val.id).then(res => {
        if (res.data.status === 200) {
          this.$message({message: res.data.message, type: 'success', duration: 1500})
          this.getPerson()
        } else {
          this.$message.error(res.data.data)
        }
      })
    },
    /* 新增联系人 */
    addContacts () {
      this.$refs['contactsForm'].validate((valid) => {
        if (valid) {
          addAppointmentContacts(this.contactsForm).then(res => {
            if (res.data.status === 200) {
              this.$message({message: res.data.message, type: 'success', duration: 1500})
              this.dialogFormVisible = false
              this.getPerson()
            } else {
              this.$message.error(res.data.message)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bookBox-1{
  /deep/ .el-tabs__content{
    padding: 0 0px 20px;
  }
  .titlebox{
    display: flex;
    margin: 10px 0 10px 0;
    h2{
      font-size: 18px;
      line-height: 32px;
      flex: 1;
      min-width: 0;
      height: 32px;
      border: none;
      margin: 0;
    }
    /deep/ .el-button{
      height: 32px;
      padding: 6px 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/personalcenter/usercontact.vue